const collection = {
    slug: "vetements-2027ss-after-demna-paris-return-guide",
    metaTitle:
      "VETEMENTS 2027SS・ヴェトモン2027SS解説｜VETEMENTS買取・デザイナーズブランド買取",
    metaDescription:
      "VETEMENTS 2027SS、ヴェトモン2027SSをデムナ退任後のブランド変化、グラム・ヴァザリア、パリ復帰の文脈から解説。VETEMENTS買取・ヴェトモン買取をはじめ、ブランド品買取、デザイナーズブランド買取、洋服買取までEnclopediaが査定視点を案内します。",
    metaKeywords:
      "VETEMENTS 2027SS,VETEMENTS 2027春夏,ヴェトモン 2027SS,ヴェトモン 2027春夏,VETEMENTS パリコレ,VETEMENTS パリ復帰,VETEMENTS Demna,VETEMENTS デムナ,VETEMENTS Guram Gvasalia,グラム・ヴァザリア,デムナなき後のVETEMENTS,VETEMENTS Sharon Stone,VETEMENTS 買取,ヴェトモン 買取,VETEMENTS 高価買取,ブランド服 買取,デザイナーズブランド 買取,洋服 買取,ファッションレンタル,ブランド服 レンタル,アーカイブファッション レンタル,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/vetements-2027ss-after-demna-paris-return-guide",
  
    heroImage:
      "media/archive_fashion/archive34.png",
    heroImageAlt:
      "VETEMENTS 2027SSとDemna退任後のブランド変化を読み解くEnclopediaアーカイブガイド",
    heroNumber: "34 / RETURN TO PARIS",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "VETEMENTS 2027SS｜デムナヴェザリア後、VETEMENTSは誰のブランドになったのか",
  
    lead:
      "VETEMENTS 2027SS。\n\nブランドは、2021年以来となるパリ・メンズ公式カレンダーへ戻ってきました。\n\n約5年という空白を経た復帰。\n\nしかし、単純な復活ではありません。\n\nVETEMENTSは消えていたわけではなく、コレクションも発表し続けていました。2022年にはGuram Gvasaliaによるフィジカルショーもパリで開催されています。\n\n今回戻ったのは、ショーそのものではない。\n\nパリの公式な場所です。\n\nそして現在のVETEMENTSに、共同創業者であり初期のデザインを率いたDemna Gvasaliaは関わっていません。\n\nDemnaは2019年にブランドを離れ、Guramは2021年末、FW22-23から自身がクリエイティブ・ディレクターを務めることを公表しました。\n\nそれでもVETEMENTSについて語られるとき、現在までDemnaの名前が付いて回ります。\n\n巨大なフーディー。\n極端に長い袖。\n既製品の転用。\n企業ロゴ。\nDHL。\n再構築されたLevi’s。\n日常着の誇張。\nファッション業界への皮肉。\n\nVETEMENTSというブランド名より、Demnaという作者の記憶の方が強く残っている。\n\nだから2027SSで問われたのは、新しいシルエットだけではありません。\n\n“DemnaがいないVETEMENTSは、何を根拠にVETEMENTSであり続けるのか”。\n\nパリ地下のトンネル。\n縫い目がほどけたスーツ。\n切りっぱなしの袖口。\nパンツからはみ出すシャツ。\n裏返されたネクタイ。\n花が刺繍されたモトクロスジャケット。\nテクニカルメッシュに切り替えられたトレンチ。\nそして、Sharon Stone。\n\n過去の騒音をそのまま再生するのではなく、既存服の小さな秩序をずらし、VETEMENTSの言語を静かに確認し直していました。\n\nEnclopediaでは、このシーズンを“5年ぶりの復活”ではなく、GuramがVETEMENTSというブランドの著者権を、パリで公に引き受け直したコレクションとして読み解きます。",
  
    keywordLine: [
      "vetements 2027ss",
      "after demna",
      "return to paris",
      "archive and authorship",
    ],
  
    thesis:
      "VETEMENTS 2027SSの本質は、初期VETEMENTSの衝撃を再現したことではありません。Demnaの影が消えないブランドに対して、Guram Gvasaliaが服、場所、キャスティング、公式カレンダーという制度を使い、現在のVETEMENTSにも独立した作者と時間が存在することを示したシーズンです。",
  
    whyTitle:
      "VETEMENTSは、なぜ再びパリの公式カレンダーを必要としたのか。",
  
    whyBody:
      "初期VETEMENTSは、ファッションの制度に認められることより、その制度を不安定にすることで存在感を得ました。\n\n高級服とは見なされてこなかったフーディー。\n企業制服。\n警備員の服。\n観光客の服。\n古着のようなデニム。\n過剰に大きい日常着。\n\nそれらをパリへ持ち込み、何がファッションで、何が商品で、誰が価値を決めるのかを問い直した。\n\nそのブランドが、2027SSでは再びパリ・メンズの公式カレンダーへ戻っています。\n\nこれは、初期の反制度的な精神を捨てたというだけではありません。\n\nブランドを取り巻く条件が変化したからです。\n\n創業時のVETEMENTSは、外側から制度を攻撃できました。\nしかし、世界的な知名度、高価格、巨大なロゴ、アーカイブ市場を持つ現在のVETEMENTSは、すでに制度の一部です。\n\nさらに、初期の創造性はDemna個人の功績として記憶され、ブランドそのものの所有物ではなくなりつつありました。\n\nその状態で公式カレンダーへ戻ることは、単なる広報ではありません。\n\n“現在のVETEMENTSもパリのファッション史へ記録されるべき存在である”と主張する行為です。\n\n公式な場所を批判するブランドから、公式な場所を使って自身の継続性を証明するブランドへ。\n\nEnclopediaでは、この変化を矛盾とは考えません。\n\nVETEMENTSが反抗する若い集団から、自らの歴史を背負うファッションハウスへ変わった証拠だと考えます。",
  
    pillars: [
      {
        number: "01",
        title: "AFTER DEMNA",
        text:
          "Demnaは2019年にVETEMENTSを離れ、Guram GvasaliaはFW22-23からクリエイティブ・ディレクターを務めています。2027SSは、Demna不在を隠すのではなく、その不在を前提にブランドを再定義するショーです。",
      },
      {
        number: "02",
        title: "INSTITUTIONAL RETURN",
        text:
          "5年ぶりという表現が指すのは、パリでのショー自体ではなく、2021年以来の公式メンズカレンダー復帰です。VETEMENTSは制度の外から攻撃するのではなく、制度の中で自らの存在を再登録しました。",
      },
      {
        number: "03",
        title: "QUIET DISRUPTION",
        text:
          "初期のロゴや巨大なプロポーションによる即時的な衝撃から、縫い目、袖口、シャツの裾、ネクタイの方向を少しずらす静かな違和感へ。破壊の音量ではなく、精度が変化しています。",
      },
      {
        number: "04",
        title: "ARCHIVE AS AUTHORITY",
        text:
          "現在のVETEMENTSは過去を持たない新興ブランドではありません。初期作、Demna退任、Guram期という複数の時間を持つアーカイブブランドになりつつあります。",
      },
    ],
  
    readingTitle:
      "地下トンネル、未完成のスーツ、逆向きのネクタイ、戦争の記憶、Sharon Stoneから読むVETEMENTS 2027SS。",
  
    readingIntro:
      "2027SSは、巨大なロゴや話題性の高い既製品転用だけで成立したコレクションではありません。Guram Gvasaliaは、オフィスウェア、スーツ、シャツ、ネクタイ、トレンチといった既知の服を用い、その完成を支える小さな秩序をずらしました。初期VETEMENTSが街で見つけた服をファッションへ引き上げたとすれば、現在のVETEMENTSは、すでにファッションとなった自分たちの言語を分解しています。",
  
    observations: [
      {
        index: "01",
        title:
          "まず確認すべきこと。現在のVETEMENTSにDemnaは関わっていない",
        text:
          "VETEMENTS 2027SSを理解するには、作者を曖昧にしてはいけません。\n\nDemna Gvasaliaは、兄弟のGuram Gvasaliaや匿名的なチームとともに、2014年にVETEMENTSを設立しました。\n\n初期コレクションのクリエイティブを率い、ブランドの巨大なシルエット、日常着の誇張、企業ロゴ、既製服の転用、サブカルチャー的なキャスティングを世界へ広めました。\n\nしかしDemnaは2019年にVETEMENTSを退任しています。\n\nその後はデザインチームによる期間を経て、Guramが2021年末、FW22-23から自身がクリエイティブ・ディレクターを務めると発表しました。\n\n現在の公式サイトにも、VETEMENTSはGuram Gvasaliaのクリエイティブ・ディレクション下にあると明記されています。\n\nしたがって2027SSを“DemnaによるVETEMENTSの復帰”と理解することはできません。\n\nこれは、GuramのVETEMENTSです。",
      },
      {
        index: "02",
        title:
          "それでも、VETEMENTSはDemnaの名前から自由になれていない",
        text:
          "作者が交代しても、ブランドの記憶はすぐには書き換わりません。\n\nVETEMENTSという名前を聞いて、多くの人が思い浮かべるのは初期の巨大なフーディー、DHL、再構築デニム、極端な肩、長い袖、ソーシャルメディアを占拠したストリートスナップです。\n\nそれらはブランドのコードであると同時に、Demna個人の方法として認識されています。\n\nここにGuram期の難しさがあります。\n\n初期のコードを使えば、兄の模倣だと見られる。\n使わなければ、VETEMENTSではないと言われる。\n\nつまりGuramが引き継いだのは、自由に使えるブランドコードではありません。\n\n誰が所有しているのかが争われ続ける言語です。\n\n2027SSは、この不安定な著者性を隠さず、コレクションの中心に置いたように見えます。",
      },
      {
        index: "03",
        title:
          "初期VETEMENTSは、最初からDemna一人だけの物語ではなかった",
        text:
          "VETEMENTSは、単独デザイナーの名前を冠したブランドではありません。\n\nブランド名の“vêtements”は、フランス語で単純に“服”を意味します。\n\n創業当初は、Demna、Guram、そして匿名的なデザインチームによる集団として語られていました。\n\n作者の神格化より、複数の人間によって服が作られる現実を前面に出していた。\n\nしかしブランドが成功すると、メディアは理解しやすい一人の天才を必要とします。\n\nその役割を担ったのがDemnaでした。\n\n結果として、集団を名乗ったブランドの歴史が、一人の作者の物語へ変換された。\n\nGuramの現在は、その物語からブランドを取り戻す試みでもあります。",
      },
      {
        index: "04",
        title:
          "Guramは、経営者から突然デザイナーになったわけではない",
        text:
          "GuramはVETEMENTSの共同創業者であり、長くCEOとしてブランドの経営、流通、戦略を担っていました。\n\nクリエイティブ・ディレクター就任時には、パターンメイキング、構造、デザイン理論などを約2年間学んでいたと説明しています。\n\nこれは重要です。\n\nDemnaが服の内側から制度を観察したデザイナーだったとすれば、Guramはビジネスの側からブランドと制度を見てきた人物です。\n\n作る服が似て見えることはあっても、立っている場所が違います。\n\nGuramにとってVETEMENTSは、批評の媒体であるだけでなく、守り、継続し、所有権を主張しなければならない組織でもある。\n\n2027SSの公式復帰には、デザインだけでなく、ブランド経営者としての視点も含まれています。",
      },
      {
        index: "05",
        title:
          "“5年ぶり”とは、5年間ショーをしていなかったという意味ではない",
        text:
          "2027SSは、2021年以来となるパリ・メンズ公式カレンダーへの復帰です。\n\nただし、VETEMENTSがその間まったくフィジカルショーをしていなかったわけではありません。\n\nGuramは2022年、パリのクチュール期間中に自身初となるVETEMENTSのフィジカルショーを開催しています。\n\nそのショーは公式クチュールカレンダーには属さず、Guramは格式の高い場所ではなく“現実の生活が起きている場所”を求めていました。\n\nしたがって2027SSの変化は、ショーを再開したことではありません。\n\n非公式な周縁から、公式なメンズカレンダーへ戻ったことです。\n\nここを区別しなければ、復帰の意味を見誤ります。",
      },
      {
        index: "06",
        title:
          "かつて制度を不要としたブランドが、制度を必要とするようになった",
        text:
          "初期VETEMENTSは、ランウェイの開催時期や販売スケジュール、格式ある会場、ラグジュアリーの常識を何度もずらしました。\n\nブランドは、制度に適応しないこと自体を力にできた。\n\nしかし2027SSでは、公式カレンダーへの復帰がニュースになっています。\n\nEnclopediaでは、この変化をブランドの敗北とは考えません。\n\n若いブランドは、制度の外側にいることで注目を得られます。\n\nしかし歴史を持ったブランドは、外側にいるだけでは、自らの時間を公式なファッション史へ残せません。\n\nGuramにとってパリ復帰は、認可を求めることより、現在のVETEMENTSを記録させることだったのではないか。\n\nこれは公表された唯一の理由ではなく、ショーの位置付けから導くEnclopediaの解釈です。",
      },
      {
        index: "07",
        title:
          "地下トンネルは、初期VETEMENTSの会場を再現するためではない",
        text:
          "2027SSの会場には、パリのGrenelle地区の地下トンネルが選ばれました。\n\n華美な宮殿でも、白いギャラリーでもありません。\n\n暗く、都市インフラに近く、完成されたファッションの夢から距離を置いた場所です。\n\n初期VETEMENTSも、クラブ、レストラン、教会、地下空間など、伝統的ランウェイとは異なる場所を選びました。\n\nしかし今回の地下は、若いブランドによるゲリラ的な侵入ではありません。\n\n世界的ブランドが公式カレンダーへ戻るために、あえて地下を選んでいる。\n\n公式制度へ参加しながら、空間だけは制度の下層に置く。\n\n復帰と反抗を同時に成立させる、非常にVETEMENTS的な選択です。",
      },
      {
        index: "08",
        title:
          "初期の“騒音”から、2027SSの“静かな違和感”へ",
        text:
          "初期VETEMENTSの衝撃は、一枚の写真でも伝わりました。\n\n巨大すぎるフーディー。\n長すぎる袖。\nDHLのロゴ。\n肩から大きく落ちるアウター。\n左右非対称のドレス。\n\n対して2027SSでは、違和感がより細部へ移っています。\n\n袖口が処理されていない。\n縫い目が開いている。\nシャツの裾がベルト下から不自然に飛び出す。\nネクタイが裏向きに締められる。\n\n服全体を異常化するのではなく、社会的に正しい服を成立させる小さな規則を一つだけずらす。\n\n一見普通に見えるのに、どこか間違っている。\n\n衝撃の音量が下がり、観察の精度が上がっています。",
      },
      {
        index: "09",
        title:
          "オフィスウェアは、現在のVETEMENTSにとって新しい現実着である",
        text:
          "2027SSでは、スーツ、シャツ、ネクタイ、ベルト付きパンツなど、オフィスウェアの要素が目立ちました。\n\n初期VETEMENTSが街のフーディー、制服、クラブウェア、観光客の服を観察したとすれば、今回は企業で働く人間の服が対象になっています。\n\n若い会社員が急いで着たようなスーツ。\n処理されない袖口。\n裾を収めきれないシャツ。\n正しい向きを失ったネクタイ。\n\nここで批評されているのは、スーツの伝統だけではありません。\n\n服装を整える余裕を失った労働者の身体です。\n\n完璧に管理された企業服の内部から、疲労、焦り、未完成さが漏れ出している。\n\nEnclopediaでは、2027SSのテーラリングを“ドレスアップへの転換”ではなく、現在の労働着を観察した結果として読みます。",
      },
      {
        index: "10",
        title:
          "切りっぱなしの袖は、服の未完成ではなく社会人の未完成を見せる",
        text:
          "ジャケットやシャツの袖口が切りっぱなしになっているとき、通常は脱構築的なデザインとして説明されます。\n\nしかし2027SSでは、オフィスウェアと組み合わされることで別の意味が生まれます。\n\nスーツは、身体を社会的に完成させる服です。\n\n肩を整える。\nシャツを収める。\nネクタイを中央へ置く。\n袖口を適切な長さに揃える。\n\nその最後の処理だけが終わっていない。\n\n社会へ出る準備が整ったように見えながら、端部には不安定さが残る。\n\nGuramのVETEMENTSは、服を壊しているというより、完成した社会人という幻想をほどいているように見えます。",
      },
      {
        index: "11",
        title:
          "逆向きのネクタイは、権威を破壊せず、少しだけ滑稽にする",
        text:
          "ネクタイは、男性服における権威、礼節、組織への所属を示す道具です。\n\n2027SSでは、そのネクタイが裏向きに使われ、通常隠されるラベルや裏面が正面へ出されました。\n\nネクタイ自体を捨てるのではありません。\n\n正しい結び方を一つだけ間違える。\n\nその結果、権威の記号は完全に破壊されず、少しだけ滑稽になります。\n\nここに今季の方法が集約されています。\n\nVETEMENTSは、既存服を認識不能にする必要がない。\n\n誰もが知る服を残したまま、正しさの向きを反転させるだけでよいのです。",
      },
      {
        index: "12",
        title:
          "縫い目が見えることは、ブランドの継承問題そのものに重なる",
        text:
          "服の縫い目は通常、完成後には意識されません。\n\nしかし2027SSでは、縫い代、切り替え、ほどけた端、内側の構造が表面へ現れます。\n\nこれはVETEMENTSというブランドの現在にも重なります。\n\nDemna退任後、誰が服を作っているのか。\n誰がコードを所有しているのか。\nどこまでが初期の継承で、どこからがGuramの創造なのか。\n\n完成したブランドイメージの裏側にある接合部が、外から見えている。\n\n今季の服が少し未完成に見えるのは、現在のVETEMENTS自身が、作者交代後の接合部を完全には隠していないからかもしれません。",
      },
      {
        index: "13",
        title:
          "モトクロスジャケットと花は、強さの中に私的記憶を差し込む",
        text:
          "モトクロスジャケットには、速度、競技、保護、男性的な攻撃性という記号があります。\n\n2027SSでは、その機能的なパネルへ花の刺繍が組み込まれました。\n\n通常なら、ハードとロマンティックの対比として処理される組み合わせです。\n\nしかしGuramは今季を、幼少期の記憶、戦争のトラウマ、隠された欲望、歪んだ想像力の集積として説明しています。\n\nそのため花は、単なる装飾的な反対要素ではありません。\n\n防護する服の表面から、守られていなかった私的な記憶が現れている。\n\n競技用の硬い外殻と、個人の感情が一着の中で重なります。",
      },
      {
        index: "14",
        title:
          "トレンチとテクニカルメッシュは、服の内部をX線のように露出させる",
        text:
          "トレンチコートには、軍服、雨、都市生活、社会的な匿名性という歴史があります。\n\n2027SSでは、そのトレンチがテクニカルメッシュと接続され、裏側の構造が透けるように見えました。\n\n外側で身体を保護するはずのコートが、内側を隠さない。\n\nこれは単なる異素材切替ではありません。\n\nVETEMENTSが現在行っている、ブランド内部の公開に近い。\n\n初期コードをどのように組み直しているのか。\nGuramの個人的記憶がどこへ入っているのか。\n服のどこが既存で、どこが新しいのか。\n\n完成品の皮膚を透かし、構造を見せる服です。",
      },
      {
        index: "15",
        title:
          "Guramのコレクションでは、社会批評と自伝が接近している",
        text:
          "Demna期のVETEMENTSにも、ジョージア、難民経験、戦争、ヨーロッパ社会への違和感は存在していました。\n\nしかし初期の強さは、それらを個人の告白だけでなく、街の服や社会的ステレオタイプへ変換したことにあります。\n\nGuramの2027SSでは、幼少期の記憶、戦争のトラウマ、隠された欲望といった個人的な言葉が、より直接的にコレクションへ置かれています。\n\nつまり観察の方向が、社会の外側だけでなく、作者の内側へ向かっている。\n\nDemnaが現実の服を通して社会を暴いたとすれば、GuramはVETEMENTSの服を通して、自身とブランドの記憶を整理しようとしているように見えます。",
      },
      {
        index: "16",
        title:
          "Demnaは社会を観察し、Guramはブランドそのものを観察している",
        text:
          "両者の違いを、シルエットだけで説明することはできません。\n\nDemna時代のVETEMENTSは、すでに街にある服を観察しました。\n\n誰がフーディーを着るのか。\nなぜ制服には権威があるのか。\nなぜ企業ロゴは高級ブランドのロゴより価値が低いのか。\nなぜ古着のデニムは完成品として認められないのか。\n\n対象は、社会とファッションシステムでした。\n\n一方、Guram期が観察しているのは、VETEMENTS自身です。\n\nブランドコードは誰のものか。\n巨大なシルエットは今も有効か。\n挑発を続けなければVETEMENTSではないのか。\nDemnaの記憶をどこまで背負うべきか。\n\n社会批評のブランドが、自己批評の段階へ入っています。",
      },
      {
        index: "17",
        title:
          "これは“Demnaに似ているか”だけで評価すべきコレクションではない",
        text:
          "GuramのVETEMENTSを見るとき、多くの評価はDemnaとの比較に戻ります。\n\nシルエットが似ている。\nスタイリングが似ている。\n初期ほど新しくない。\n兄の方法を引き継いでいる。\n\n比較は必要です。\n\nしかし、それだけではブランド継承の本質を見逃します。\n\nファッションハウスは、作者が変わっても過去のコードを使います。\nDiorのニュールック。\nChanelのツイード。\nMargielaの足袋。\nBalenciagaのアーカイブシルエット。\n\nVETEMENTSだけに完全な断絶を求めれば、ブランドとして継続すること自体が不可能になります。\n\n問うべきなのは、似ているかではありません。\n\n受け継いだコードに、現在の作者が新しい問題を与えられているかです。",
      },
      {
        index: "18",
        title:
          "2027SSで変わったのは、誇張の大きさより服の壊し方である",
        text:
          "VETEMENTSには現在も、オーバーサイズ、長い袖、誇張されたテーラリング、ストリートとフォーマルの混在が残っています。\n\nしかし2027SSで注目すべきなのは、服を巨大化させることより、完成状態を少し崩すことです。\n\n縫い目を開く。\n裾を出す。\nネクタイを裏返す。\n裏地を透かす。\n異なる感情を刺繍として差し込む。\n\n服の外形全体を変えるのではなく、正しく着られている状態を不安定にする。\n\n初期VETEMENTSがプロポーションによって遠くから認識されたとすれば、2027SSは近づいて初めて異常に気づく服です。",
      },
      {
        index: "19",
        title:
          "Sharon Stoneは、単なるセレブリティ・キャスティングではない",
        text:
          "ショーを締めくくったのはSharon Stoneでした。\n\n白いオーバーサイズブレザー、解体された黒いシャツ、裏向きのネクタイ、黒いロングブーツ。\n\nStoneは1990年代の映画、セクシュアリティ、権力、スターイメージを背負う人物です。\n\n同時に、『Basic Instinct』を象徴する彼女のイメージは、DemnaのGucciをめぐる文脈とも奇妙に響き合います。\n\nそのため、この起用には兄弟間の間接的な対話を読み取ることもできます。\n\nただし、ブランドから明言された意図ではありません。\n\n確実に言えるのは、Guramが無名のリアルピープルだけでなく、巨大な既成イメージを持つスターを利用し、そのイメージをVETEMENTSの衣服へ取り込んだことです。",
      },
      {
        index: "20",
        title:
          "初期の匿名的キャスティングから、スターを使うブランドへ",
        text:
          "初期VETEMENTSは、ストリートキャスト、友人、クラブカルチャーの人物、既存のモデル規範から外れた身体によって現実感を作りました。\n\n2027SSのSharon Stoneは、その方向とは異なります。\n\n匿名的な現実ではなく、世界中が知る映画的記憶をキャスティングする。\n\nこれは、VETEMENTSがアンダーグラウンドな集団から、巨大な文化的イメージを操作できるハウスへ変わったことを示します。\n\n反セレブリティからセレブリティへ転向したという単純な話ではありません。\n\n無名の人間に既製服を着せて現実を作る段階から、既知の人物に服を着せ、既存の記憶を上書きする段階へ移ったのです。",
      },
      {
        index: "21",
        title:
          "今のVETEMENTSは、反ファッションではなくファッションハウスである",
        text:
          "VETEMENTSはいまだに、反ファッション、反制度、ストリート、アンダーグラウンドという言葉で語られます。\n\nしかし現在のブランドは、世界的な流通網、高価格の商品、公式カレンダー、セレブリティ、10年以上のアーカイブを持っています。\n\nもはや制度の外側にいる小さな集団ではありません。\n\nそれを隠しながら初期の反抗を演じ続ければ、過去の模倣になります。\n\n2027SSの重要性は、自分たちがすでにファッションハウスになったことを認め、その状態から違和感を作ろうとした点にあります。\n\nVETEMENTSはファッションを否定するブランドから、ファッションハウスになった後に何を批評できるかを問うブランドへ変わっています。",
      },
      {
        index: "22",
        title:
          "パリ復帰は、ブランドの反抗ではなく存続を可視化する行為だった",
        text:
          "現在のファッション市場では、ブランドが商品を販売し続けていても、ショーを行わず、批評されず、公式カレンダーに存在しなければ、文化的には見えなくなっていきます。\n\nVETEMENTSはその間も大きな商品を作り、販売し、知名度を保っていました。\n\nしかしブランドの話題は、しばしば初期作かDemnaとの比較へ戻っていた。\n\nだから公式カレンダーへの復帰は、売るためだけでなく、現在形のVETEMENTSを批評対象へ戻す必要があったのではないか。\n\nパリに戻ることで、ブランドは“まだ存在する”だけでなく、“現在もファッションを提案している”と宣言できます。",
      },
      {
        index: "23",
        title:
          "VETEMENTSは、現在進行形のブランドであると同時にアーカイブブランドになった",
        text:
          "創業から10年以上が経ち、VETEMENTSには複数の時代が生まれています。\n\n初期の匿名的コレクティブ。\nDemnaが率いた拡張期。\nBalenciagaとの並行期。\n2019年の退任。\nデザインチームの期間。\nGuramの就任。\n公式メンズカレンダーへの復帰。\n\n一つのブランド内に、異なる作者と目的が存在する。\n\nこの時点でVETEMENTSは、単なる現在のストリートブランドではありません。\n\nシーズン、デザイナー、グラフィック、ボディ、コラボレーションによって価値が変わるアーカイブブランドです。\n\n過去作をすべて“昔のVETEMENTS”として一括りにするのではなく、どの時期の何を記録した服なのかを読む必要があります。",
      },
      {
        index: "24",
        title:
          "初期VETEMENTSの価値は、ロゴの知名度だけではない",
        text:
          "中古市場では、VETEMENTSの価値がロゴや有名グラフィックだけで判断されることがあります。\n\nしかし初期作の重要性は、ブランド名が大きく書かれているかだけではありません。\n\n肩線の位置。\n袖の長さ。\n身幅と着丈の比率。\n既製品の転用方法。\nLevi’sの再構築。\n制服やワークウェアの引用。\nグラフィックが置かれた社会的背景。\n\nそれらが、2010年代のファッションにどのような変化を与えたかまで含めて価値が形成されます。\n\n単なるオーバーサイズではなく、なぜその大きさが必要だったのかを見る必要があります。",
      },
      {
        index: "25",
        title:
          "Guram期は、初期作より価値が低いと一律に判断できない",
        text:
          "Demna期の知名度と歴史的重要性が高いため、初期VETEMENTSに注目が集まりやすいのは事実です。\n\nしかし、Guram期のアイテムをすべて二次的なものとして扱うべきではありません。\n\n作者交代後のコード。\n新しいグラフィック。\n極端なテーラリング。\n個人的な戦争記憶。\nスターとの関係。\nブランドがハウス化する過程。\n\nこれらは今後、VETEMENTS史を区分するうえで重要な資料になります。\n\n2027SSの公式復帰によって、Guram期は単なる空白期間ではなく、独立した章として評価され始める可能性があります。",
      },
      {
        index: "26",
        title:
          "VETEMENTS買取で見るべきなのは、年代、作者、ボディ、文脈である",
        text:
          "VETEMENTSの査定では、ブランド名だけでは価値を判断できません。\n\nDemna在籍期か、退任後か。\nどのシーズンか。\nランウェイ登場作か。\nオリジナルボディか、既製品の再構築か。\nグラフィックの背景は何か。\nコラボレーション作品か。\nサイズとフィットはどうか。\n付属品や加工が残っているか。\n\n特にVETEMENTSは、同じ“オーバーサイズフーディー”でも年代、ボディ、プリント、シルエットによって意味が大きく異なります。\n\nEnclopediaでは、ロゴの大きさだけではなく、服がどの時代のブランド思想を記録しているかまで確認します。",
      },
      {
        index: "27",
        title:
          "ただしEnclopediaの買取は、VETEMENTSだけに限定されない",
        text:
          "この記事を読んで、VETEMENTSの価値を相談したい方だけを対象としているわけではありません。\n\nEnclopediaでは、COMME des GARÇONS、JUNYA WATANABE、sacai、Yohji Yamamoto、Maison Margiela、Raf Simons、Rick Owens、Prada、Miu Miu、CELINE、Balenciagaをはじめ、国内外のデザイナーズブランドを取り扱っています。\n\n一着だけの査定。\n複数ブランドをまとめた査定。\nシーズン不明のアイテム。\n古いコレクション。\nコラボレーション作品。\n\nブランドを一つに絞らず、ワードローブ全体を文脈と市場性の両面から確認します。",
      },
      {
        index: "28",
        title:
          "“高く売れるブランドだけ送る”必要はない",
        text:
          "買取を検討するとき、所有者自身が価値のある服を選別しようとすると、重要なアーカイブが見落とされることがあります。\n\nブランドタグが古い。\n品番が読めない。\n購入時期を覚えていない。\n一見すると普通のシャツやパンツに見える。\n付属品が不足している。\n\nそのような場合も、写真から確認できます。\n\nVETEMENTS以外のブランドを含め、全体写真、ブランドタグ、品質表示、特徴的なディテールをLINEで送ることで、査定対象になるか事前に相談できます。",
      },
      {
        index: "29",
        title:
          "レンタルでは、VETEMENTSだけでなくブランド間の影響関係を体験する",
        text:
          "VETEMENTSの影響は、一つのブランド内に閉じていません。\n\nオーバーサイズ。\n日常着の誇張。\n企業ロゴ。\nストリートとラグジュアリーの逆転。\n既製服の再構築。\n社会階級を映すスタイリング。\n\nこれらは、Balenciagaをはじめ、その後の多くのファッションへ波及しました。\n\nEnclopediaのレンタルでは、VETEMENTSだけを探すのではなく、COMME des GARÇONS、Maison Margiela、Raf Simons、sacai、JUNYA WATANABE、Balenciagaなど、異なる方法で既製服を読み替えてきたブランドを横断して体験できます。\n\n一つの服を着ることが、ブランド間の違いを知る入口になります。",
      },
      {
        index: "30",
        title:
          "アーカイブを着ることは、写真で似ている服の違いを確かめること",
        text:
          "VETEMENTS以降、オーバーサイズのフーディーや極端な肩、長い袖は広く普及しました。\n\n画面上では、多くのブランドが似て見えることがあります。\n\nしかし実際に着ると違います。\n\n肩線がどこから落ちるのか。\n袖の重量が動作をどう変えるか。\nフードが首の後ろへどれだけ溜まるか。\n身幅に対して着丈がどう設定されているか。\nプリントが身体のどの位置に来るか。\n\nアーカイブの価値は、画像上のインパクトだけではありません。\n\n身体へ乗せたときに、当時の新しさが現在でも機能するかを確認できることです。",
      },
      {
        index: "31",
        title:
          "2027SSは、VETEMENTSが復活したショーではない",
        text:
          "VETEMENTSは、2027SS以前もブランドとして活動していました。\n\nしたがって“復活”という言葉は正確ではありません。\n\n戻ったのは、パリ・メンズの公式な舞台です。\n\nそして、そこで再提示されたのは初期の騒乱ではなく、作者交代後のブランドが抱えてきた不安定さでした。\n\n未完成のスーツ。\n裏返されたネクタイ。\n露出する縫い目。\n個人的記憶。\n地下空間。\n\nVETEMENTSは完成した過去を祝うのではなく、現在も接合途中にある自分自身を見せたのです。",
      },
      {
        index: "32",
        title:
          "Demnaなき後のVETEMENTSとは、ブランド名が作者になろうとする過程である",
        text:
          "初期VETEMENTSでは、Demnaという作者がブランドを前へ押し出しました。\n\n現在は逆です。\n\nVETEMENTSというブランド名が、過去の作者、現在の作者、匿名的なチーム、商品、アーカイブをまとめ、一つのハウスとして自立しようとしている。\n\nGuramの役割は、Demnaの代わりになることではありません。\n\nDemnaがいなくても、ブランドの言語が更新され、過去と現在が接続され、次の作者へ渡せる状態を作ることです。\n\n2027SSのパリ復帰は、その工程を公の場へ出したコレクションだったのではないでしょうか。",
      },
    ],
  
    quote:
      "VETEMENTS 2027SSでパリへ戻ったのは、初期の反抗ではない。Demnaの記憶からブランドを引き離し、VETEMENTSという名前そのものを作者にするための時間です。",
  
    perspectiveTitle:
      "Enclopediaは、VETEMENTS 2027SSを“5年ぶりの復活”ではなく、“作者交代後のブランドがパリで自身の継続性を証明したコレクション”として扱う。",
  
    perspectiveCards: [
      {
        number: "01",
        title: "AUTHORSHIP",
        text:
          "Demna退任後のVETEMENTSを、兄弟の単純な比較ではなく、ブランドコードの所有権と継承という観点から読み解きます。",
      },
      {
        number: "02",
        title: "INSTITUTION",
        text:
          "公式カレンダー復帰を単なる話題作りではなく、周縁から生まれたブランドが、自身の歴史を制度内へ記録する行為として考察します。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "初期Demna期、移行期、Guram期を区別し、シーズン、構造、グラフィック、社会的背景からアーカイブ価値を見ます。",
      },
    ],
  
    experienceTitle:
      "VETEMENTS 2027SSを入口に、国内外のデザイナーズブランドを売る・借りる・比較する。",
  
    experienceBody:
      "VETEMENTS 2027SSは、一般販売前のシーズンです。\n\nそのため、現在すぐに買取やレンタルの対象となるのは、2027SSそのものではありません。\n\n初期Demna期のVETEMENTS。\nDemna退任前後の移行期。\nGuram Gvasaliaによる現在のVETEMENTS。\nそしてVETEMENTSと同じ時代を形成してきた、他ブランドのアーカイブです。\n\nEnclopediaの目的は、VETEMENTSだけを集めることではありません。\n\nCOMME des GARÇONS、JUNYA WATANABE、sacai、Yohji Yamamoto、Maison Margiela、Raf Simons、Rick Owens、Balenciaga、Prada、CELINEなど、ブランドごとに異なる服の思想を保存し、次の着用者へつなぐことです。\n\n所有している服の価値を確認したい方は、複数ブランドをまとめて買取相談できます。\n\nVETEMENTSを起点に他ブランドとの違いを体験したい方は、Enclopediaでレンタルできるファッションアーカイブ全体をご覧ください。",
  
    experienceItems: [
      "VETEMENTSのブランドタグ、品質表示、品番を確認する",
      "Demna在籍期、移行期、Guram期のいずれに該当するか確認する",
      "購入時期が不明な場合も、タグと全体写真を送る",
      "フーディー、Tシャツ、アウター、デニムなどアイテムカテゴリーを確認する",
      "肩幅、袖丈、身幅、着丈などVETEMENTS特有のプロポーションを確認する",
      "グラフィック、刺繍、プリント、加工の状態を撮影する",
      "ランウェイ登場作、コラボレーション、初期作品かを確認する",
      "Levi’s、Champion、Reebok、Alpha Industriesなど協業タグを確認する",
      "裾、袖、縫い目の加工がデザインか損傷かを確認する",
      "付属タグ、ハンガー、袋、替えパーツがあれば一緒に送る",
      "VETEMENTS以外のデザイナーズブランドもまとめて相談する",
      "シーズンや市場価値を自分で判断せず、LINEで写真査定を依頼する",
    ],
  
    archiveItemsTitle:
      "VETEMENTSだけに絞らず、ファッションアーカイブ全体の買取・レンタルへ。",
  
    archiveItemsBody:
      "Enclopediaでは、VETEMENTSの買取実績だけを強調するのではなく、国内外のデザイナーズブランドを横断して査定しています。ブランド単体では判断しにくい服も、デザイナー、シーズン、構造、コレクション背景、現在の市場性から確認します。またレンタルでは、特定ブランドだけでなく、Enclopediaが保有するファッションアーカイブ全体を体験できます。",
  
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "デザイナーズブランドをまとめてLINE査定する",
        productPath: "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "VETEMENTS、COMME des GARÇONS、sacai、Yohji Yamamoto、Maison Margiela、Raf Simons、Rick Owens、Balenciagaなど、複数ブランドをまとめて相談できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "Enclopediaのレンタルアイテムをすべて見る",
        productPath: "/",
        productImage: "",
        text:
          "VETEMENTSだけに限定せず、国内外のデザイナーズブランド、コレクションピース、アーカイブアイテムを横断してレンタルできます。",
      },
      {
        label: "BUYBACK FOCUS 03",
        title: "Enclopediaのブランド買取を見る",
        productPath: "/brand_buyback",
        productImage: "",
        text:
          "ブランドごとの買取方針、査定で確認するポイント、宅配買取の流れを案内します。掲載されていないブランドもLINEから相談できます。",
      },
      {
        label: "ARCHIVE FOCUS 04",
        title: "ブランドとコレクションから服を知る",
        productPath: "/archive_collection",
        productImage: "",
        text:
          "服を価格やブランド名だけで選ばず、デザイナー、シーズン、構造、社会背景を読んだうえで、買取とレンタルへつなげます。",
      },
    ],
  
    buybackGuide: {
      label: "BUYBACK / ALL DESIGNER BRANDS",
      title:
        "VETEMENTSの価値を知ることから、ワードローブ全体の価値を見直す。",
      body:
        "VETEMENTSは、年代やシーズンによって評価軸が大きく異なるブランドです。\n\nしかし、それはVETEMENTSだけではありません。\n\nデザイナーズブランドの価値は、ブランド名だけでなく、デザイナーの在籍時期、コレクションテーマ、ランウェイでの位置付け、素材、構造、サイズ、状態、現在の需要によって変わります。\n\nEnclopediaでは、VETEMENTSの買取相談を入口に、他ブランドを含むワードローブ全体を確認できます。\n\n買取ページに個別掲載のないブランドや、査定実績を公表していないブランドでも、対象外とは限りません。\n\nまずはLINEで、全体写真、ブランドタグ、品質表示、特徴的なディテールをお送りください。",
      buttonLabel: "複数ブランドをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  
    rentalGuide: {
      label: "RENTAL / COMPLETE ARCHIVE",
      title:
        "VETEMENTSを探すことから、別のブランドを着ることへ。",
      body:
        "Enclopediaのレンタルは、一つのブランドだけを目的としたサービスではありません。\n\nCOMME des GARÇONSの構造。\nJUNYA WATANABEの再構築。\nsacaiのハイブリッド。\nMaison Margielaの匿名性。\nRaf Simonsのユースカルチャー。\nYohji Yamamotoの身体と布。\nBalenciagaやVETEMENTSによる日常着の誇張。\n\n同じ“オーバーサイズ”や“再構築”でも、ブランドによって考え方は異なります。\n\n複数のアーカイブを実際に着ることで、画像や説明だけでは見えない違いを身体で比較できます。",
      buttonLabel: "レンタルできる全アイテムを見る",
      buttonHref: "/",
    },
  
    finalCta: {
      title:
        "VETEMENTS 2027SSを読んだら、一つのブランドではなく、ワードローブ全体の次を考える。",
      body:
        "2027SSでVETEMENTSがパリへ戻したのは、初期の騒乱ではありません。\n\nDemna退任後もブランドが継続し、Guram Gvasaliaのもとで別の時間を獲得していることでした。\n\n服の価値も、現在の知名度だけでは決まりません。\n\n誰が作ったのか。\nいつ発表されたのか。\n何を問い直した服なのか。\n現在、どのような文脈で読み直せるのか。\n\nEnclopediaでは、VETEMENTSを含む国内外のデザイナーズブランドを、シーズンと構造まで確認して買取します。\n\nまた、VETEMENTSだけに限定せず、Enclopediaが保有するファッションアーカイブ全体をレンタルできます。\n\n売ることも、着ることも、ブランド名だけで判断しない。\n服が持つ時間を、次の所有者と着用者へつなげます。",
      primaryButtonLabel: "ブランド服をまとめてLINE査定する",
      primaryButtonHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryButtonLabel: "レンタルできる全アイテムを見る",
      secondaryButtonHref: "/",
    },
  };
  
  export default collection;
